import { useAuth } from "@providers/AuthProvider";
import React from "react";

type CheckPermissionProps = {
    permissions: string|string[]|boolean;
    requireAll?: boolean;
    children: any;
}

export function CheckPermission({permissions, fails = false, requireAll = false, children, ...restProps}:CheckPermissionProps) {
    const { can } = useAuth();

    const checkAbility = can(permissions, requireAll);
    const hasAbility = fails ? !checkAbility : checkAbility;

    if(!hasAbility) {
        return null;
    }

    // toArray allows multiple children without wrapping in a fragment
    const arrayChildren = React.Children.toArray(children);
    return (<>
    {arrayChildren.map((child, index) => {
        if(~['string', 'number'].indexOf(typeof child)) {
            return <>{child}</>;
        }
        if(React.isValidElement(child)) {
        // this is required to ensure that joy styles work as expected
        const childrenProps = {
            key: index,
            ...restProps,
            ...children.props,
        };

        return React.cloneElement(child, childrenProps);
    }
    })}
    </>)

    /*
    // from joy tooltip
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        component,
        ...children.props,
        className: clsx(className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...(followCursor ? { onMouseMove: handleMouseMove } : {}),
    };
    */

    // return <>{React.isValidElement(children) && React.cloneElement(children, childrenProps)}</>;
}
